import { ProcessState } from '../../types/processes/processTypes';
import { readOnlyEntities } from '../../utils/commonVariables/entityKeys';
import { buildOdataEndPoint } from '../../utils/odataEndPoint';
import api from '../api';
import {
    adaptProcessesToState,
    ScrapingExecutionProcess,
} from './processesAdapters';
import { PROCESS_RESULTS_LIMIT } from '../../utils/processes/processesUtils';

interface ProcessesResponse {
    value: ScrapingExecutionProcess[];
}

/**
 * Loads scraping executions and their processes via owner-scoped server OData.
 * @returns The newest executions in every state, up to PROCESS_RESULTS_LIMIT.
 */
export const getProcesses = async (): Promise<ProcessState[]> => {
    const endpoint = buildOdataEndPoint({
        entity: readOnlyEntities.ZitoneoScrapingExecution,
        expand: ['Process'],
        orderBy: 'DateCreated desc',
        top: PROCESS_RESULTS_LIMIT,
        select: [
            'Id',
            'DateCreated',
            'IdProcess',
            'Process/Completed',
            'Process/Cancelled',
            'Process/Failed',
            'Process/ProcessedTime',
            'Process/Name',
        ],
    });
    const { data } = await api.get<ProcessesResponse>(endpoint);
    return adaptProcessesToState(data.value);
};
